import React from "react";

import { Container } from "../components/Container";

import { Hero } from "../components/Hero";
import { SectionTitle } from "../components/SectionTitle";
import { Benefits } from "../components/Benefits";
import { Quality } from "../components/Quality";




// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"



export default function Home() {

  const { i18n } = useTranslation();



  let data = dataFR;
  if (i18n.language === "fr") {
    data = dataFR;
  } else if (i18n.language === "en") {
    data = dataEN;
  } else if (i18n.language ==="nl"){
    data = dataNL;
  }


  return (
    <Container>
      <Hero />
      <SectionTitle
        preTitle={data.home.preTitle}
        title={data.home.title}
      >
        {data.home.desc}
      </SectionTitle>

      <Benefits data={data.benefitOne} />    
        <Quality imgPos="right" />      
    </Container>
  );
}
